import theme from '@styles/theme';
export default {
  linkContainer: {
    gridColumn: ['1 / -1', 'initial']
  },
  container: {
    width: '100%',
    height: '100%'
  },
  blockContainer: (backgroundColor: string) => ({
    position: 'relative',
    background: backgroundColor || 'transparent',
    width: '100%',
    paddingTop: [0, '100%'],
    'h5.headings.heading__three.mobile': {
      fontSize: [theme.fontSizes.h3]
    }
  }),
  content: {
    position: ['relative', 'absolute'],
    width: ['100%', 'unset'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: 'hidden',
    p: ['40px 40px 80px', '40px 40px 80px', '64px 64px 104px', '24px 24px 64px', '24px 24px 64px', '40px 24px 80px']
  },
  description: (color: string, row: number) => ({
    color,
    width: '100%',
    display: row > 0 ? '-webkit-box' : ['block', 'none'],
    WebkitLineClamp: ['unset', row],
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    mt: '16px',
    fontSize: '16px !important',
    lineHeight: '175%',
    letterSpacing: '0.16px'
  }),
  iconContainer: {
    position: 'absolute',
    width: ['24px', '32px', '40px'],
    height: ['24px', '32px', '40px'],
    bottom: [40, 40, 64, 24, 24, 40],
    right: 24
  }
};